import { jsx } from "react/jsx-runtime";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import { validateTidalLicense } from "../../base/index.js";
function FiberNew(props) {
  return /* @__PURE__ */ jsx(
    FiberNewIcon,
    {
      "data-testid": "FiberNew",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FiberNew",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
FiberNew.tidalIconMeta = {
  categories: "miscellaneous",
  name: "FiberNew"
};
validateTidalLicense();
export {
  FiberNew
};
//# sourceMappingURL=FiberNew.js.map
